import { useState, useEffect, useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { isMobile } from 'react-device-detect';
import { Button, Group, Input, MultiSelect, Autocomplete, MantineProvider, Textarea, Select} from '@mantine/core';
import { BedethequeContext } from '../utils/context/bedetheque'
import HeaderPage from '../components/headerPage';
import { Checkbox  } from '@mantine/core';
import { grabAlbum, createAlbumInBedetheque } from '../libs/apiController';
import { myConsoleLog } from '../libs/constantes'
import Spinner from "../components/molecules/Spinner";
import AuteurAutocomplete from "../components/molecules/AuteurAutocomplete";
import { STATUT_SERIE_OPTIONS } from '../libs/statutSerie';
import '../utils/style/grab.css';

const paddingStyle = {
    margin : '10px'
}

function Grab() {
    const {genres, auteurs, bedethequeAndWishlistBySerie, setReload} = useContext(BedethequeContext);
    const navigate = useNavigate();

    const [urlToGrab, setUrlToGrab] = useState(null)
    const [albumGrab, setAlbumGrab] = useState(null)
    const [loading, setLoading] = useState(false)

    const [chkCouleur, setChkCouleur] = useState(true);
    const [chkTirageLimite, setChkTirageLimite] = useState(false);
    const [chkIntegrale, setChkIntegrale] = useState(false);
    const [chkFinDeCycle, setChkFinDeCycle] = useState(false);
    const [selStatutSerie, setSelStatutSerie] = useState(null);
    
    const [serieTrouve, setSerieTrouve] = useState(false);
    const [tomeTrouve, setTomeTrouve] = useState(false);

    const [grabSerie, setGrabSerie] = useState();
    const [grabIdSerie, setGrabIdSerie] = useState();
    const [grabTome, setGrabTome] = useState();
    const [grabTitre, setGrabTitre] = useState();
    const [grabGenre, setGrabGenre] = useState([]);
    const [grabEditeur, setGrabEditeur] = useState();
    const [grabParution, setGrabParution] = useState();    
    const [grabScenaristes, setGrabScenaristes] = useState();
    const [grabDessinateurs, setGrabDessinateurs] = useState();
    const [grabRemarques, setGrabRemarques] = useState();
    const [grabResume, setGrabResume] = useState();
    const [grabCouverture, setGrabCouverture] = useState();

    const constBedethequeComUrl = 'https://www.bedetheque.com';
    
    async function resetStates() {
        setAlbumGrab(null)
        setGrabSerie(null)
        setGrabIdSerie(null)
        setGrabTome(null)
        setGrabTitre(null)
        setGrabGenre(null)
        setGrabEditeur(null)
        setGrabParution(null)
        setGrabScenaristes(null)
        setGrabDessinateurs(null)
        setGrabRemarques(null)
        setGrabResume(null)
        setGrabCouverture(null)
        setChkFinDeCycle(false)
        setSelStatutSerie(null)
    }

    useEffect(() => {
        if(!!albumGrab) {
            setSerieTrouve(albumGrab.trouve?.serie?.trouve)
            setTomeTrouve(albumGrab.trouve?.album?.trouve)
            setChkCouleur(true)

            setGrabSerie(albumGrab.serie)
            setGrabTome(albumGrab.tome)
            setGrabTitre(albumGrab.album)

            if(albumGrab.trouve?.serie?.trouve) {
                setGrabIdSerie(albumGrab.trouve.serie.item?.idserie)
                setGrabGenre(albumGrab.trouve.serie.item?.genre)
            } else {
                // on a le numero de serie à créer via le module grab du serveur
                setGrabIdSerie(albumGrab.trouve.idserie)
            }
            setGrabParution(albumGrab.parution)
            setGrabEditeur(albumGrab.editeur)
            setGrabResume(albumGrab.resume)
            setGrabRemarques(albumGrab.remarque)
            setGrabCouverture(albumGrab.couverture)

            // Chaque auteur scrapé est résolu contre la base : trouvé → réutilisé (✅),
            // sinon il sera créé à l'enregistrement. Fallback dessinateurs = scénaristes
            // quand le scraping n'en ramène pas (one-shots).
            const sce = (albumGrab.scenaristes || []).map(resolveScraped)
            const des = (albumGrab.dessinateurs?.length ? albumGrab.dessinateurs : (albumGrab.scenaristes || [])).map(resolveScraped)
            setGrabScenaristes(sce)
            setGrabDessinateurs(des)
        }

    }, [albumGrab, auteurs]) // eslint-disable-line react-hooks/exhaustive-deps

    async function handleSetGrabGenre(e) {
        setGrabGenre(e)
    }
   
    async function handleGenre(event) {
        let arrGenre = event.target.value.split(',').map((item) => item.trim())
        setGrabGenre(arrGenre)
    }

    async function handleclick() {
        if(!urlToGrab || !urlToGrab.startsWith(constBedethequeComUrl)) return
        setLoading(true)
        myConsoleLog(urlToGrab)
        await grabAlbum(urlToGrab)
        .then((response) => {
            setAlbumGrab(response)
        })
        .finally(() => {
            setLoading(false)
        })
    }

    const handleChange = (e) => {
        setUrlToGrab(e.target.value)
    };

    const handleKeyPress = (e) => {
        if(e.key === 'Enter' && urlToGrab.startsWith(constBedethequeComUrl)){
            handleclick()
        }
    };

    async function handleClickBedetheque(isWishlist) {
        if(!grabGenre?.length || !grabSerie?.length) return

        let jsonBody = {
            tome: grabTome,
            titre: grabTitre,
            parution: grabParution,
            scenaristes: grabScenaristes,
            dessinateurs: grabDessinateurs,
            editeur: grabEditeur,
            couverture: grabCouverture,
            idserie: grabIdSerie,
            serie: grabSerie,
            genre: grabGenre,
            remarque: grabRemarques,
            resume: grabResume,
            couleur: +chkCouleur,
            integrale: +chkIntegrale,
            tiragelimite: +chkTirageLimite,
            finDeCycle: chkFinDeCycle,
            statutSerie: selStatutSerie,
            note: 0,
            wishlist: +isWishlist
        }

        await createAlbumInBedetheque(jsonBody)
        .then((response) => {
            myConsoleLog(response)
        })
        .finally(() => {
            setReload(true);
            navigate('/');
        })
    }

    /* TODO :
         - si dessinateur == scenariste : modifier icone en face du nom
    */


    const handleChangeInputSerie = (value) => {
        let foundIndex = bedethequeAndWishlistBySerie.findIndex(x => x.serie === value);
        let trouve = bedethequeAndWishlistBySerie[foundIndex]
        setGrabSerie(value.length ? value : " ")
        setSerieTrouve(false)
        if(trouve) {
            setGrabSerie(trouve.serie)
            setGrabGenre(trouve.genre)
            setGrabIdSerie(trouve.idserie)
            setSerieTrouve(true)
        } else {
            if(albumGrab.trouve?.serie?.trouve) {
                setGrabIdSerie(albumGrab.trouve.serie.item?.idserie)
                setGrabGenre(albumGrab.trouve.serie.item?.genre)
            } else {
                setGrabIdSerie(albumGrab.trouve.idserie)
                setGrabGenre("")
            }
        }
    }
          
    // Résout un nom contre les auteurs en base (insensible à la casse) :
    // trouvé → {_id, nom} (réutilisé) ; sinon → {nom} (créé à l'enregistrement).
    const resolveScraped = (nom) => {
        const found = (auteurs || []).find((a) => a.nom.toLowerCase() === nom?.trim().toLowerCase())
        return found ? { _id: found._id, nom: found.nom } : { nom: nom?.trim() }
    }

    const updateAuteurAt = (role, idx, newValue) => {
        const resolved = resolveScraped(newValue)
        const setter = role === 'scenariste' ? setGrabScenaristes : setGrabDessinateurs
        setter((prev) => prev.map((a, i) => (i === idx ? resolved : a)))
    }

    const handleChangeInputTomeNum = (evt) => {
        setGrabTome(evt.target.value)
    }

    const handleChangeInputTomeTitre = (evt) => {
        setGrabTitre(evt.target.value)
    }

    return (
        <>
        <HeaderPage leftText={''} centerText={'Grab album'} rightText={''}/>        
            
        {loading &&
            <div className="pos-center">
                <Spinner />
            </div>
        }

        {!albumGrab && !loading &&
        <>
        <Group position="center" style={{'paddingTop': '15px'}}>
            <Input 
                radius="lg"
                size="xl"
                placeholder="bedetheque album url"
                onChange={handleChange}
                onKeyDown={handleKeyPress}
                className="search-input-text"
                autoFocus
            />
            <Button color={'lime'} radius={'xl'} size="md" onClick={ handleclick }>GO</Button>
        </Group>
        <br/>
        
        <Group position="center">
            <MantineProvider inherit theme={{ defaultGradient: { from: 'white', to: 'grey', deg: 45, }, }} >
                <Button variant="gradient" radius={'xl'} size="md" style={{color: 'grey'}} onClick={ () => window.open(constBedethequeComUrl, '_blank', 'noreferrer') }>{constBedethequeComUrl.split('https://www.')[1]}</Button>
            </MantineProvider>
        </Group>
        </>
        }
       
        {!!albumGrab && 
        <>
        <div className='buttonContainer' style={{paddingTop: '15px'}}>
            <div className="buttonCreate">
                
            <Group position="center">
                <MantineProvider
                    inherit
                    theme={{
                    defaultGradient: {
                        from: '#69DB7C',
                        to: '#74B816',
                        deg: 45,
                    },                        
                    }}
                >
                    <Button variant="gradient" onClick={() => handleClickBedetheque(false)}>BEDETHEQUE</Button>
                </MantineProvider>
                <Button onClick={() => resetStates()}>X</Button>
                <MantineProvider
                    inherit
                    theme={{
                    defaultGradient: {
                        from: '#F783AC',
                        to: '#D6336C',
                        deg: 45,
                    },
                    }}
                >
                    <Button variant="gradient" onClick={() => handleClickBedetheque(true)}>&nbsp;&nbsp;&nbsp;WISHLIST&nbsp;&nbsp;&nbsp;</Button>
                </MantineProvider>
            
            </Group>
            </div>
        </div>
        <div className={isMobile ? "spaceContainerMobile" : "spaceContainer"}>
            <div className="space">                
            
                <div className="albumContainer">
                    
                    <div className='image'>
                        <article className="serie-comic">
                            <div className="serie-panel">
                                <img src={grabCouverture} alt={grabSerie}></img>
                                <p className="serie-text serie-bottom-right">
                                    <input value={grabEditeur} size={12} />
                                    &nbsp;(<input value={grabParution} size={5} />)
                                </p>                        
                            </div>
                        </article>
                    </div>
                    
                    <div className="detail">
                        
                        <div className="serie-comic">
                            <div className="serie-panel serie-bg-blue">
                                <div style={paddingStyle}>
                                    <MultiSelect
                                        searchable
                                        mt="sm"
                                        value={grabGenre}
                                        data={genres}
                                        placeholder="Genre"
                                        onChange={(e) => { handleSetGrabGenre(e)}}
                                    />
                                    {bedethequeAndWishlistBySerie && grabSerie &&
                                        <Autocomplete
                                            icon={'📚'}
                                            defaultValue={grabSerie}
                                            onChange={(e) => handleChangeInputSerie(e)}
                                            data={bedethequeAndWishlistBySerie}
                                            rightSection={serieTrouve ? '✅' : ''}
                                        />
                                    }
                                    
                                    <Input icon={'#️⃣'} size="sm" placeholder="Numéro de tome" value={grabTome} onChange={(e) => handleChangeInputTomeNum(e)} rightSection={tomeTrouve && '✅'}/>
                                    <Input icon={'📙'} size="sm" placeholder="Titre du tome" value={grabTitre} onChange={(e) => handleChangeInputTomeTitre(e)} />

                                    {grabScenaristes?.map((sce, idx) => (
                                        <span key={`sce-${idx}`}>
                                            <AuteurAutocomplete
                                                icon={'🖊️'}
                                                value={sce.nom}
                                                rightSection={sce._id ? '✅' : ''}
                                                onChange={(val) => updateAuteurAt('scenariste', idx, val)}
                                            />
                                        </span>
                                    ))}
                                    {grabDessinateurs?.map((des, idx) => (
                                        <span key={`des-${idx}`}>
                                            <AuteurAutocomplete
                                                icon={'🖌️'}
                                                value={des.nom}
                                                rightSection={des._id ? '✅' : ''}
                                                onChange={(val) => updateAuteurAt('dessinateur', idx, val)}
                                            />
                                        </span>
                                    ))}
                                    
                                    <Input icon={'🔖'} size="sm" value={grabGenre?.toString()} onChange={(e) => handleGenre(e)}/>
                                    <Input icon={'📌'} size="sm" onChange={(e) => setGrabRemarques(e.target.value)}/>
                                </div>

                            </div>
                        </div>
                        
                        <div>
                            <article className="serie-comic">
                                <div className="serie-panel serie-bg-blue">
                                    <Checkbox label="Couleur" className='checkbox-album' size="sm" radius="xl"
                                        checked={chkCouleur} 
                                        onChange={(event) => {
                                            setChkCouleur(event.currentTarget.checked)
                                            }} />
                                    <Checkbox label="Tirage limité" className='checkbox-album' size="sm" radius="xl" 
                                        checked={chkTirageLimite}  
                                        onChange={(event) => {
                                            setChkTirageLimite(event.currentTarget.checked)
                                            }} />
                                    <Checkbox label="Intégrale" className='checkbox-album' size="sm" radius="xl"
                                        checked={chkIntegrale}
                                        onChange={(event) => {
                                            setChkIntegrale(event.currentTarget.checked)
                                            }} />
                                    <Checkbox label="Fin de cycle" className='checkbox-album' size="sm" radius="xl"
                                        checked={chkFinDeCycle}
                                        onChange={(event) => {
                                            setChkFinDeCycle(event.currentTarget.checked)
                                            }} />
                                    <Select
                                        className='statut-serie-select'
                                        placeholder="Statut série"
                                        clearable
                                        withinPortal
                                        size="xs"
                                        data={STATUT_SERIE_OPTIONS}
                                        value={selStatutSerie}
                                        onChange={(value) => setSelStatutSerie(value)}
                                    />
                                </div>
                            </article>
                        </div>

                        {albumGrab.resume?.length >1 &&
                        <div className="resume">
                            <div className="serie-comic">
                                <div className="serie-panel serie-bg-green">
                                    <p className="serie-text serie-top-left">Résumé</p>
                                    <div className='resume-text'>
                                        <Textarea
                                            autosize
                                            variant={'default'}
                                            size={'sm'}
                                            radius={'md'}
                                            value={grabResume}
                                            onChange={(e) => setGrabResume(e.target.value)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        }
                    </div>
                    
                    
                    
                </div>
                
            </div>

        </div>
        </>
        }
        </>
    )
}

export default Grab;